var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentifying5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72727 6.69091L6.69091 8.72727L3.63636 5.67273L5.67273 3.63636L8.72727 6.69091ZM13.0909 30.5455C13.0909 31.4182 13.6727 32 14.5455 32H17.4545C18.3273 32 18.9091 31.4182 18.9091 30.5455V29.0909H13.0909V30.5455ZM0 17.4545H4.36364V14.5455H0V17.4545ZM17.4545 0H14.5455V4.36364H17.4545V0ZM27.6364 14.5455V17.4545H32V14.5455H27.6364ZM26.3273 3.63636L23.2727 6.69091L25.3091 8.72727L28.3636 5.67273L26.3273 3.63636ZM24.7273 16C24.7273 19.2 22.9818 22.1091 20.3636 23.5636V26.1818C20.3636 27.0545 19.7818 27.6364 18.9091 27.6364H13.0909C12.2182 27.6364 11.6364 27.0545 11.6364 26.1818V23.5636C9.01818 22.1091 7.27273 19.2 7.27273 16C7.27273 11.2 11.2 7.27273 16 7.27273C20.8 7.27273 24.7273 11.2 24.7273 16ZM16 10.1818C14.5455 10.1818 13.2218 10.7345 12.2036 11.6364H19.7964C18.7782 10.7345 17.4545 10.1818 16 10.1818Z",
    fill: "#1CCEDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentifying5);
export default __webpack_public_path__ + "static/media/identifying5.b5ef108088077f9f62db77b639153a6e.svg";
export { ForwardRef as ReactComponent };